import { render, staticRenderFns } from "./DashboardCompanyUsers.vue?vue&type=template&id=252c8cbc&scoped=true"
import script from "./DashboardCompanyUsers.vue?vue&type=script&lang=js"
export * from "./DashboardCompanyUsers.vue?vue&type=script&lang=js"
import style0 from "./DashboardCompanyUsers.vue?vue&type=style&index=0&id=252c8cbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c8cbc",
  null
  
)

export default component.exports